import Api from "@/api"
import { usePagedFilteredSearching } from "@/composition/usePageFilteredSearching"
import { SortDirection } from "@/models"
import { VtsSortBy, type SearchVtsFilter, type SearchVtsRequest, type SearchVtsResult } from "@/models/VtsLogSearch"
import { toReactive } from "@vueuse/core"
import { toRef } from "vue"
import { RefQueries, useQueryStoreRef } from "vue-utils"

const defaultRequestOptions = (): SearchVtsRequest => ({
	page: 1,
	pageSize: 12,
	filter: {
		fromIds: [],
		toIds: [],
	},
	sortBy: VtsSortBy.LogTime,
	sortDirection: SortDirection.Descending,
})

export function useVtsLogSearch() {
	const { loadableRef: vtsLogsRef, ...rest } = usePagedFilteredSearching<SearchVtsResult, SearchVtsRequest>({
		loadValue: async (request) => await Api.vts.search(request),
		getDefault: defaultRequestOptions,
	})
	return {
		vtsLogsRef,
		...rest,
	}
}

export function bindVtsLogRequestToQuery(request: SearchVtsRequest) {
	useQueryStoreRef("page", request, "page", RefQueries.Int)
	useQueryStoreRef("page-size", request, "pageSize", RefQueries.Int)
	useQueryStoreRef("by", request, "sortBy", RefQueries.nullableEnum(VtsSortBy))
	useQueryStoreRef("sort", request, "sortDirection", RefQueries.nullableEnum(SortDirection))

	const filterRef = toReactive(toRef(request, "filter"))
	bindVtsLogFilterToQuery(filterRef)
}

export function bindVtsLogFilterToQuery(filter: SearchVtsFilter) {
	useQueryStoreRef("from", filter, "fromIds", RefQueries.arrayOf(RefQueries.Int))
	useQueryStoreRef("to", filter, "toIds", RefQueries.arrayOf(RefQueries.Int))
}
